import {
    CommunicationStatsReadError,
    CommunicationStatsResponse,
    getCommunicationStats,
    toCommunicationStatsReadError,
} from "@/shared/api/communication-stats"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const fetchCommunicationServices = createAsyncThunk<
    CommunicationStatsResponse,
    void,
    { rejectValue: CommunicationStatsReadError }
>("communicationServices/fetch", async (_, thunkApi) => {
    try {
        return await getCommunicationStats()
    } catch (error: unknown) {
        return thunkApi.rejectWithValue(toCommunicationStatsReadError(error))
    }
})
